var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-input-field"},[_c('b-form-group',{attrs:{"label":_vm.label,"label-class":"form-label","label-for":_vm.id}},[_c('b-input-group',{attrs:{"append":_vm.append,"id":_vm.id}},[_c('b-form-input',{attrs:{"value":_vm.formValue},on:{"input":function($event){return _vm.$emit('change', _vm.formValue)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }